export const FRONTEND_ERROR_PREFIX: string = "-f";
export const EMAIL_NOT_PROVIDED: string = FRONTEND_ERROR_PREFIX + 1;
export const PASSWORD_NOT_PROVIDED: string = FRONTEND_ERROR_PREFIX + 2;
export const EMAIL_PASSWORD_NOT_PROVIDED: string = FRONTEND_ERROR_PREFIX + 3;
export const EMAIL_NOT_VALID: string = FRONTEND_ERROR_PREFIX + 4;
